import React from 'react'
import { Navigate } from 'react-router-dom'
/*import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainHeader from 'components/navigation/MainHeader'
import ScrapingContent from 'components/modules/products/scraping/ScrapingContent'
import SubscriptionInfo from 'components/modules/settings/SubscriptionsInfo'

import { isSubscriptionActive } from 'utils/functions'
import { selectUserSubscriptionView } from 'store/user/selectors'
import { UserActionsTypes } from 'store/user/actions'
import { logAmplitudeEvent } from 'utils/analytics'*/

const ScrapingPage: React.FC = () => {
  return <Navigate to="/" replace />

  /*const dispatch = useDispatch()
  const crumbsItems = [
    {
      label: 'Overview',
      to: '/',
    },
    {
      label: 'Scraper APIs',
      isActive: true,
    },
  ]

  const subscriptionInfo = useSelector(selectUserSubscriptionView)

  const isUserSubscriptionActive = isSubscriptionActive(subscriptionInfo)
  const isDemoModeAvailable = !subscriptionInfo?.status

  useEffect(() => {
    if (isDemoModeAvailable) {
      logAmplitudeEvent('Preview Scraper APIs product view')
    }
  }, [])

  useEffect(() => {
    if (isUserSubscriptionActive) {
      dispatch({ type: UserActionsTypes.USER_GET_SCRAPPER_API_KEY })
    }
  }, [dispatch, isUserSubscriptionActive])

  return (
    <>
      <MainHeader crumbsItems={crumbsItems} />
      {isSubscriptionActive(subscriptionInfo) || isDemoModeAvailable ? (
        <ScrapingContent />
      ) : (
        <SubscriptionInfo reducedDisplayMode />
      )}
    </>
  )*/
}

export default ScrapingPage
